export default [

    // ? duplicacion
    // ! /movil/prepago/recargas
    {to: '/movil/prepago/recargas_',from: '/movil/prepago/recargas/online__', value: 4281}, // !
    {to: '/movil/prepago/recargas_',from: '/movil/preplan__',value: 2936}, // !
    {to: '/movil/prepago/recargas_',from: '/movil/prepago/paquetes__',value: 1850}, // !
    {to: '/movil/prepago/recargas_',from: '/movil/prepago/promociones-prepago__',value: 1224},
    {to: '/movil/prepago/recargas_',from: '/beneficios-prepago__',value: 1063}, // !
  
    // ! /movil/preplan
    {to: '/movil/preplan_',from: '/movil/prepago/recargas__',value: 2179}, // !
    {to: '/movil/preplan_',from: '/beneficios-prepago__',value: 1507}, // !
    {to: '/movil/preplan_',from: '/movil/prepago/paquetes__',value: 816}, // !
    {to: '/movil/preplan_',from: '/movil/prepago/recargas/online__',value: 433}, // !

    // ! /beneficios-prepago
    {to: '/beneficios-prepago_',from: '/movil/prepago/recargas__',value: 1996}, // !
    {to: '/beneficios-prepago_',from: '/movil/prepago/paquetes__',value: 998}, // !
    {to: '/beneficios-prepago_',from: '/movil/preplan__',value: 726}, // !
    {to: '/beneficios-prepago_',from: '/movil/prepago/recargas/online__',value: 198}, // !
    
    // ! /movil/prepago/paquetes
    {to: '/movil/prepago/paquetes_',from: '/movil/prepago/recargas__',value: 1778}, // !
    {to: '/movil/prepago/paquetes_',from: '/beneficios-prepago__',value: 993}, // !
    {to: '/movil/prepago/paquetes_',from: '/movil/preplan__',value: 854}, // !
    {to: '/movil/prepago/paquetes_',from: '/movil/prepago/recargas/online__',value: 509}, // !

    // ! /movil/prepago/recargas/online
    {to: '/movil/prepago/recargas/online_',from: '/movil/prepago/recargas__',value: 4051}, // !
    {to: '/movil/prepago/recargas/online_',from: '/movil/preplan__',value: 260}, // !
    {to: '/movil/prepago/recargas/online_',from: '/movil/prepago/paquetes__',value: 197}, // !

  // ? Original
  // ! /movil/prepago/recargas
  {to: '/movil/prepago/recargas',from: '/movil/prepago/recargas/online_', value: 4281},
  {to: '/movil/prepago/recargas',from: '/movil/preplan_',value: 2936},
  {to: '/movil/prepago/recargas_',from: '/home_',value: 1881},
  {to: '/movil/prepago/recargas',from: '/movil/prepago/paquetes_',value: 1850},
  {to: '/movil/prepago/recargas_',from: '/movil/prepago/promociones-prepago_',value: 1224},
  {to: '/movil/prepago/recargas',from: '/beneficios-prepago_',value: 1063},
  {to: '/movil/prepago/recargas_',from: '/movil/prepago_',value: 256},
  {to: '/movil/prepago/recargas_',from: '/movil/conoce-tus-numeros-moviles_', value: 149},
  {to: '/movil/prepago/recargas_',from: '/quedate-en-casa_',value: 147},
  {to: '/movil/prepago/recargas_',from: '/movil/bienvenida_',value: 144},

  // ! /movil/preplan
  {to: '/movil/preplan',from: '/movil/prepago/recargas_',value: 2179},
  {to: '/movil/preplan_',from: '/home_',value: 1711},
  {to: '/movil/preplan',from: '/beneficios-prepago_',value: 1507},
  {to: '/movil/preplan',from: '/movil/prepago/paquetes_',value: 816},
  {to: '/movil/preplan_',from: '/movil/prepago_',value: 535},
  {to: '/movil/preplan',from: '/movil/prepago/recargas/online_',value: 433},
  {to: '/movil/preplan_',from: '/movil/prepago/promociones-prepago_',value: 342},
  {to: '/movil/preplan_',from: '/movil/postpago/planes-postpago_',value: 331},
  {to: '/movil/preplan_',from: '/movil/conoce-tus-numeros-moviles_',value: 182},

  // ! /beneficios-prepago
  {to: '/beneficios-prepago',from: '/movil/prepago/recargas_',value: 1996},
  {to: '/beneficios-prepago',from: '/movil/prepago/paquetes_',value: 998},
  {to: '/beneficios-prepago',from: '/movil/preplan_',value: 726},
  {to: '/beneficios-prepago_',from: '/home_',value: 374},
  {to: '/beneficios-prepago',from: '/movil/prepago/recargas/online_',value: 198},
  {to: '/beneficios-prepago_',from: '/movil/prepago/promociones-prepago_',value: 141},
  {to: '/beneficios-prepago_',from: '/movil/postpago/planes-postpago_',value: 90},
  {to: '/beneficios-prepago_',from: '/quedate-en-casa_',value: 68},
  
  // ! /movil/prepago/paquetes
  {to: '/movil/prepago/paquetes',from: '/movil/prepago/recargas_',value: 1778},
  {to: '/movil/prepago/paquetes_',from: '/home_',value: 1049},
  {to: '/movil/prepago/paquetes',from: '/beneficios-prepago_',value: 993},
  {to: '/movil/prepago/paquetes',from: '/movil/preplan_',value: 854},
  {to: '/movil/prepago/paquetes_',from: '/movil/prepago/promociones-prepago_',value: 593},
  {to: '/movil/prepago/paquetes',from: '/movil/prepago/recargas/online_',value: 509},
  {to: '/movil/prepago/paquetes_',from: '/movil/postpago/planes-postpago_',value: 248},
  {to: '/movil/prepago/paquetes_',from: '/movil/prepago_',value: 240},
  {to: '/movil/prepago/paquetes_',from: '/movil/bienvenida_',value: 134},
  
  // ! /movil/prepago/recargas/online
  {to: '/movil/prepago/recargas/online',from: '/movil/prepago/recargas_',value: 4051},
  {to: '/movil/prepago/recargas/online_',from: '/home_',value: 627},
  {to: '/movil/prepago/recargas/online',from: '/movil/preplan_',value: 260},
  {to: '/movil/prepago/recargas/online',from: '/movil/prepago/paquetes_',value: 197},
  {to: '/movil/prepago/recargas/online_',from: '/movil/prepago/promociones-prepago_',value: 154},
  {to: '/movil/prepago/recargas/online_',from: '/movil/postpago/planes-postpago_',value: 106},
  {to: '/movil/prepago/recargas/online_',from: '/movil/prepago_',value: 98},
];

